import { asc, eq, type PowerSyncDrizzleDB, saved_view } from "@listto/powersync";

/**
 * User's saved views for the sidebar, in the chosen order.
 */
export function getSavedViewsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(saved_view)
    .where(eq(saved_view.user_id, userId))
    .orderBy(asc(saved_view.sort_order), asc(saved_view.created_at));
}

/**
 * A saved view by id (detail route `/views/$viewId`).
 */
export function getSavedViewQuery(db: PowerSyncDrizzleDB, id: string) {
  return db.select().from(saved_view).where(eq(saved_view.id, id)).limit(1);
}
